import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
}));
